// API Configuration
// Update this file to change the backend URL for all API calls

const API_CONFIG = {
  // Backend URL - uses environment variable, falls back to localhost for development
  BASE_URL: process.env.REACT_APP_API_URL || "http://localhost:8000",

  // API endpoints
  ENDPOINTS: {
    // Attendance endpoints
    ATTENDANCE_USERS: "/attendance-users/",
    ATTENDANCE_RECORDS: "/attendance-records/",

    // Custom device configuration endpoints
    ATTENDANCE_CONFIG_TEST: "/attendance-config/test_custom_connection/",
    ATTENDANCE_CONFIG_USERS: "/attendance-config/get_users_with_config/",
    ATTENDANCE_CONFIG_RECORDS:
      "/attendance-config/get_records_with_config/",
  },
};

// Helper function to get full API URL
export const getApiUrl = (endpoint) => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// Helper function to get all endpoints with full URLs
export const getApiEndpoints = () => {
  const endpoints = {};
  for (const [key, value] of Object.entries(API_CONFIG.ENDPOINTS)) {
    endpoints[key] = getApiUrl(value);
  }
  return endpoints;
};

export default API_CONFIG;
